/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconAlligatorClip: {
  name: 'alligator_clip';
  data: string;
} = {
  name: 'alligator_clip',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="m225.871 935.503-21.923-11.41-1.03 1.03c1.018 1.503.67 3.82-.977 5.467s-4.017 2.051-5.52 1.03l-.977.977 11.384 21.949 9.746-5.732-6.947-.555 3.486-3.487-5.837-.449 3.038-3.038-5.256-.396 2.536-2.536-4.517-.343 2.271-2.271-3.936-.291c2.717-.493 5.076-2.837 5.573-5.573l.317 3.909 2.245-2.245.37 4.49 2.509-2.509.423 5.23 3.011-3.011.449 5.837 3.486-3.487.528 6.815 5.548-9.401z" transform="translate(-3631.284 -17252.341) scale(18.68858)"/></svg>`,
};
